/* MARMOT F2 — попъп за избор на доставка в количката (заменя middleware.bg).
   Дизайн „Колетът": стъпков поток (Данни → Доставка → Потвърждение) + винаги
   видим опаковъчен фиш. Vanilla, defer, без библиотеки.

   Чистата логика (нулиране при смяна на метод — §4.1, праг за безплатна
   доставка, валута, навигация) е в marmot-delivery-logic.js (window.MarmotF2Logic),
   за да е тестима без браузър. Този файл е DOM обвивката около нея.

   Активира се САМО когато Editera backend config-ът върне enabled:true
   (истинският kill switch) или при ?f2_preview=1 (визуален преглед в
   непубликувана тема). Иначе снипетът стои скрит и стандартният checkout
   не се пипа — нула клиентски промени, докато middleware е активен.

   Поток: количка → попъп → POST /api/shopify/checkout/draft → redirect към
   invoiceUrl. Валидацията тук огледалва shopifyCheckoutService.validateCheckoutDraft.
   buildRequest() (draft заявката) НЕ се пипа — контрактният тест срещу #D774
   зависи от нея. */
(function () {
  'use strict';

  var L = window.MarmotF2Logic;
  var CONFIG_VERSION = 1;

  // Колко офиса теглим наведнъж за ЕДИН град. Големите градове се събират цели
  // (София е най-големият случай); ендпойнтът има свой таван и връща total.
  var CITY_OFFICE_LIMIT = 500;

  // Само ВИДИМИ етикети в попъпа. Заглавието на shipping line-а в Draft Order-а
  // се строи от бекенда по courier/service (напр. „До адрес speedy") — Ф1 чете
  // адреса в този формат, контрактът #D774 стъпва на него. Тук НЕ го пипаме.
  var METHOD_LABELS = {
    'speedy:office': 'До офис или автомат на Speedy',
    'speedy:address': 'До личен адрес',
    'econt:office': 'До офис или еконтомат на Еконт'
  };

  // §4.4: етикетът на стъпка казва какво е стъпката, без чар.
  var STEP_TITLES = {
    1: 'Данни за поръчката',
    2: 'Доставка',
    3: 'Потвърждение'
  };

  var ERROR_MESSAGES = {
    CHECKOUT_DISABLED: 'Онлайн поръчката е временно недостъпна. Опитай отново по-късно или се свържи с нас.',
    // Недостижимо от 28.07.2026 – сървърът вече не връща този код (границата е
    // решена). Оставено нарочно като застраховка при rollback на библиотеката.
    FREE_SHIPPING_BOUNDARY_NOT_CONFIGURED: 'Има технически проблем с цената на доставката за тази сума. Свържи се с нас, за да завършим поръчката.',
    OFFICE_NOT_FOUND: 'Избраният офис вече не е наличен. Избери друг офис.',
    OFFICE_CACHE_EMPTY: 'Списъкът с офиси временно не е наличен. Опитай пак след малко.',
    IDEMPOTENCY_CONFLICT: 'Количката се промени. Прегледай данните и опитай пак.',
    ATTEMPT_IN_PROGRESS: 'Заявката вече се обработва. Изчакай момент и провери имейла си.',
    ATTEMPT_UNKNOWN: 'Заявката може вече да е приета. Провери имейла си, преди да опиташ отново.',
    SERVER_ERROR: 'Възникна грешка. Опитай отново след малко.',
    DRAFT_CREATE_FAILED: 'Не успяхме да създадем поръчката. Опитай отново след малко.',
    RATE_LIMITED: 'Твърде много опити. Изчакай малко и опитай пак.',
    NETWORK: 'Няма връзка със сървъра. Провери интернета и опитай пак.'
  };

  function init(root) {
    if (root.dataset.marmotInit === '1') return;
    root.dataset.marmotInit = '1';
    if (!L) return; // логическият модул трябва да е зареден преди този файл

    var store = (root.dataset.store || '').trim();
    var apiBase = (root.dataset.apiBase || '').replace(/\/+$/, '');
    if (!store || !apiBase) return;

    var params = new URLSearchParams(window.location.search);
    var previewForce = params.get('f2_preview') === '1';
    try {
      if (previewForce) sessionStorage.setItem('f2_preview', '1');
      else if (sessionStorage.getItem('f2_preview') === '1') previewForce = true;
    } catch (e) {}
    var forceActive = root.dataset.forceActive === '1';

    apiGet(apiBase + '/api/shopify/checkout/config?store=' + encodeURIComponent(store))
      .then(function (cfg) {
        if (!cfg || typeof cfg !== 'object') return;
        var active = cfg.enabled === true || previewForce || forceActive;
        if (!active) return; // дормантно — стандартният checkout остава
        new Widget(root, cfg, apiBase, store, (previewForce || forceActive) && cfg.enabled !== true);
      })
      .catch(function () { /* fail closed */ });
  }

  /* ---- Widget ---- */

  function Widget(root, cfg, apiBase, store, isPreview) {
    this.root = root;
    this.cfg = cfg;
    this.apiBase = apiBase;
    this.store = store;
    this.isPreview = isPreview;

    this.dialog = root.querySelector('[data-f2-dialog]');
    this.overlay = root.querySelector('[data-f2-overlay]');
    this.form = root.querySelector('[data-f2-form]');
    this.titleEl = root.querySelector('[data-f2-title]');
    this.rail = root.querySelector('[data-f2-rail]');
    this.methodsBox = root.querySelector('[data-f2-methods]');
    this.officeBox = root.querySelector('[data-f2-office]');
    this.cityInput = root.querySelector('[data-f2-city-q]');
    this.cityList = root.querySelector('[data-f2-city-list]');
    this.officeField = root.querySelector('[data-f2-office-field]');
    this.officeInput = root.querySelector('[data-f2-office-q]');
    this.officeList = root.querySelector('[data-f2-office-list]');
    this.officeHint = root.querySelector('[data-f2-office-hint]');
    this.foot = root.querySelector('.marmot-f2__foot');
    this.addressBox = root.querySelector('[data-f2-address]');
    this.addrCityInput = root.querySelector('[data-f2-addr-city]');
    this.addrCityList = root.querySelector('[data-f2-addr-city-list]');
    this.addrStreetField = root.querySelector('[data-f2-addr-street-field]');
    this.addrStreetInput = root.querySelector('[data-f2-addr-street]');
    this.addrStreetList = root.querySelector('[data-f2-addr-street-list]');
    this.addrDetails = root.querySelector('[data-f2-addr-details]');
    this.addrLookup = root.querySelector('[data-f2-addr-lookup]');
    this.addrFallbackBox = root.querySelector('[data-f2-addr-fallback]');
    this.backBtn = root.querySelector('[data-f2-back]');
    this.cta = root.querySelector('[data-f2-cta]');
    this.ctaLabel = root.querySelector('[data-f2-cta-label]');
    this.stepOf = root.querySelector('[data-f2-stepof]');
    this.formError = root.querySelector('[data-f2-form-error]');
    this.itemsToggle = root.querySelector('[data-f2-items-toggle]');
    this.linesBox = root.querySelector('[data-f2-lines]');

    this.state = {
      step: 1,
      courier: null,
      service: null,
      officeId: null,
      officeLabel: null,
      officeType: null,
      cityName: null,
      cityZip: null,
      addrSiteId: null,
      addrSiteName: null,
      addrZip: null,
      addrStreetId: null,
      addrStreetName: null,
      addrStreetType: null,
      addrFallback: false,
      promo: '',
      idempotencyKey: null,
      cart: null,
      open: false,
      submitting: false,
      itemsOpen: root.dataset.itemsOpen === '1',
      lastFocus: null
    };
    this.officeSearchTimer = null;
    this.officeSearchSeq = 0;
    this.cityOffices = [];
    this.cityOfficesTruncated = false;
    this.addrCityTimer = null;
    this.addrCitySeq = 0;
    this.addrStreetTimer = null;
    this.addrStreetSeq = 0;

    var termsLink = root.querySelector('[data-f2-terms-link]');
    if (termsLink && cfg.termsUrl) termsLink.setAttribute('href', cfg.termsUrl);

    this.renderMethods();
    this.bindCheckoutInterception();
    this.bindPopupControls();
    this.bindFormBehaviour();
    this.updateStepUI();
    this.updateSummary();

    document.documentElement.classList.add('has-marmot-f2');
    if (isPreview) this.showFormError('Тестов режим (?f2_preview=1): попъпът е видим, но реална поръчка не се създава, докато kill switch-ът е изключен.');
  }

  /* ---- Методи на доставка ---- */

  Widget.prototype.renderMethods = function () {
    var self = this;
    var methods = (this.cfg.methods || []).slice().sort(function (a, b) {
      return (a.displayOrder || 0) - (b.displayOrder || 0);
    });
    this.methodsBox.innerHTML = '';
    methods.forEach(function (m, i) {
      var key = m.courier + ':' + m.service;
      var id = 'marmot-f2-m-' + i;
      var wrap = document.createElement('label');
      wrap.className = 'marmot-f2__method';
      wrap.setAttribute('for', id);
      // §4.2: без обещание за срок в v1 — само име + цена.
      wrap.innerHTML =
        '<input class="marmot-f2__method-radio" type="radio" name="f2method" id="' + id + '" value="' + key + '">' +
        '<span class="marmot-f2__method-name">' + (METHOD_LABELS[key] || key) + '</span>' +
        '<span class="marmot-f2__method-price" data-price-eur="' + (m.priceEur || 0) + '">' + L.money(Math.round((m.priceEur || 0) * 100)) + '</span>';
      var input = wrap.querySelector('input');
      input.addEventListener('change', function () { self.onMethodChange(m); });
      self.methodsBox.appendChild(wrap);
    });
  };

  // При достигнат праг за безплатна доставка цената на всеки метод се зачертава
  // с „безплатно" до нея — еднозначно, без противоречие с фиша/количката.
  Widget.prototype.updateMethodPrices = function (isFree) {
    if (!this.methodsBox) return;
    var els = this.methodsBox.querySelectorAll('.marmot-f2__method-price');
    Array.prototype.forEach.call(els, function (el) {
      var eur = parseFloat(el.getAttribute('data-price-eur')) || 0;
      var base = L.money(Math.round(eur * 100));
      if (isFree) {
        el.innerHTML = '<s class="marmot-f2__method-price-old">' + escapeHtml(base) + '</s> ' +
          '<span class="marmot-f2__method-price-free">безплатно</span>';
      } else {
        el.textContent = base;
      }
    });
  };

  Widget.prototype.onMethodChange = function (m) {
    this.clearError('method');
    // §4.1 — смяна на метод: нулира офиса и обезсилва започнатия draft опит.
    var next = L.applyMethodChange(this.state, m);
    this.state.courier = next.courier;
    this.state.service = next.service;
    this.state.officeId = next.officeId;
    this.state.officeLabel = next.officeLabel;
    this.state.officeType = next.officeType;
    this.state.idempotencyKey = next.idempotencyKey;
    if (next.officeReset) { this.clearOfficeUI(); this.clearAddressUI(); }

    if (next.needsOffice) { show(this.officeBox); hide(this.addressBox); }
    else if (next.needsAddress) { hide(this.officeBox); show(this.addressBox); }
    else { hide(this.officeBox); hide(this.addressBox); }

    this.updateSummary();
    this.updateStepUI();
  };

  // Нулира UI-то на града и офиса (officeId/label/type ги нулира логическият модул).
  Widget.prototype.clearOfficeUI = function () {
    this.state.cityName = null;
    this.state.cityZip = null;
    this.cityOffices = [];
    if (this.cityInput) this.cityInput.value = '';
    if (this.officeInput) this.officeInput.value = '';
    if (this.officeField) this.officeField.hidden = true;
    this.hideAllLists();
    this.clearError('officeCity');
    this.clearError('office');
  };

  Widget.prototype.showList = function (listEl, inputEl) {
    if (listEl) listEl.hidden = false;
    if (inputEl) inputEl.setAttribute('aria-expanded', 'true');
    // Скролът се задейства ТУК, при отварянето, а не само при фокус: списъкът
    // идва след debounce-а на упита, така че по време на focusin още няма какво
    // да се скролва (телефонен тест 26.07).
    this.fitList(listEl, inputEl);
  };
  Widget.prototype.hideList = function (listEl, inputEl) {
    if (listEl) {
      listEl.hidden = true;
      listEl.style.maxHeight = '';
      listEl.classList.remove('marmot-f2__office-list--up');
    }
    if (inputEl) inputEl.setAttribute('aria-expanded', 'false');
  };

  /* Списъкът е inline (в потока), а футърът е лепнат отдолу — значи може да
     остане ПОД него. При отваряне: 1) вдигаме полето към върха на модала, за да
     има място отдолу; 2) режем височината до свободното между списъка и футъра;
     3) ако отдолу пак не стига, а отгоре има повече — отваряме нагоре. */
  var LIST_MIN_H = 140;
  var LIST_MAX_H = 320;

  Widget.prototype.fitList = function (listEl, inputEl) {
    var dlg = this.dialog;
    if (!listEl || listEl.hidden || !dlg || !inputEl) return;
    var self = this;
    var apply = function () {
      var footH = self.foot ? self.foot.offsetHeight : 0;
      var gap = 8;
      listEl.classList.remove('marmot-f2__office-list--up');
      listEl.style.maxHeight = '';

      // 1) полето колкото може по-нагоре в скролващия контейнер на модала
      var dlgTop = dlg.getBoundingClientRect().top;
      var lift = inputEl.getBoundingClientRect().top - (dlgTop + 12);
      if (lift > 1) dlg.scrollTop += lift; // браузърът клампва, ако няма накъде

      // 2) свободното място между списъка и лепнатия футър
      var dlgRect = dlg.getBoundingClientRect();
      var inputRect = inputEl.getBoundingClientRect();
      var listTop = listEl.getBoundingClientRect().top;
      var below = Math.round(dlgRect.bottom - footH - gap - listTop);
      if (below >= LIST_MIN_H) {
        listEl.style.maxHeight = Math.min(below, LIST_MAX_H) + 'px';
        return;
      }
      // 3) отдолу не стига — отваряме нагоре, ако там има повече място
      var above = Math.round(inputRect.top - dlgRect.top - gap);
      if (above > below) {
        listEl.classList.add('marmot-f2__office-list--up');
        listEl.style.maxHeight = Math.min(above, LIST_MAX_H) + 'px';
      } else {
        listEl.style.maxHeight = Math.max(below, 96) + 'px';
      }
    };
    apply();
    // На мобилен клавиатурата/адресната лента местят viewport-а след отварянето
    // — мерим втори път на следващия кадър.
    if (window.requestAnimationFrame) window.requestAnimationFrame(apply);
    else setTimeout(apply, 16);
  };
  Widget.prototype.hideAllLists = function () {
    this.hideList(this.cityList, this.cityInput);
    this.hideList(this.officeList, this.officeInput);
    this.hideList(this.addrCityList, this.addrCityInput);
    this.hideList(this.addrStreetList, this.addrStreetInput);
  };

  /* ---- Стъпкова навигация ---- */

  Widget.prototype.methodSelected = function () {
    return !!(this.state.courier && this.state.service);
  };

  Widget.prototype.goToStep = function (n) {
    n = Math.max(1, Math.min(3, n));
    this.state.step = n;
    this.hideAllLists();
    this.clearAllErrors();
    this.updateStepUI();
    // Фокус върху първото поле на стъпката, скрол до върха.
    var active = this.root.querySelector('[data-f2-step="' + n + '"]');
    if (this.dialog) this.dialog.scrollTop = 0;
    if (active) {
      var first = active.querySelector('input:not([type="hidden"]), button, select, textarea');
      if (first) { try { first.focus(); } catch (e) {} }
    }
  };

  // Напред само с бутона; на стъпка 3 → реалният чекаут.
  Widget.prototype.advance = function () {
    var step = this.state.step;
    if (step < 3) {
      // Винаги валидираме и показваме грешки — CTA-то не е тихо мъртво на стъпка
      // 2 без метод (validateStep(2) дава грешката „Избери метод на доставка").
      var errors = this.validateStep(step);
      if (this.showErrors(errors)) return;
      this.goToStep(step + 1);
    } else {
      this.submit();
    }
  };

  Widget.prototype.back = function () {
    if (this.state.step > 1) this.goToStep(this.state.step - 1);
  };

  // Рейлът позволява само връщане назад (не скок напред).
  Widget.prototype.railGoto = function (n) {
    this.goToStep(L.railTarget(this.state.step, n));
  };

  Widget.prototype.updateStepUI = function () {
    var step = this.state.step;
    var flags = L.stepFlags(step);

    for (var s = 1; s <= 3; s++) {
      var sec = this.root.querySelector('[data-f2-step="' + s + '"]');
      if (sec) sec.hidden = s !== step;
    }

    // Свити обобщения на предишните стъпки.
    this.updateRecap(1, flags.s1done, this.contactRecap());
    this.updateRecap(2, flags.s2done, this.deliveryRecap());

    // Рейл: маркиране на завършени/активна + забрана за скок напред.
    if (this.rail) {
      var items = this.rail.querySelectorAll('[data-f2-rail-step]');
      Array.prototype.forEach.call(items, function (li) {
        var n = parseInt(li.getAttribute('data-f2-rail-step'), 10);
        li.classList.toggle('is-active', n === step);
        li.classList.toggle('is-done', n < step);
        li.classList.toggle('is-upcoming', n > step);
        var btn = li.querySelector('[data-f2-goto]');
        if (btn) btn.disabled = n > step; // напред през рейла не може
      });
    }

    if (this.backBtn) this.backBtn.hidden = !flags.canBack;
    if (this.stepOf) this.stepOf.textContent = 'Стъпка ' + step + ' от 3';
    if (this.titleEl) this.titleEl.textContent = STEP_TITLES[step] || STEP_TITLES[1];

    // CTA: етикет + визуален намек „още не си готов". Бутонът НЕ е реално
    // disabled — кликът пак валидира и показва защо (напр. „Избери метод"),
    // затова без aria-disabled (би било в разрез с това, че е активен).
    var enabled = L.canAdvance(step, this.methodSelected());
    if (this.ctaLabel) this.ctaLabel.textContent = L.ctaLabel(step, this.methodSelected());
    if (this.cta) this.cta.classList.toggle('is-disabled', !enabled);

    if (step === 3) this.updateReview();
  };

  Widget.prototype.updateRecap = function (n, visible, valueText) {
    var recap = this.root.querySelector('[data-f2-recap="' + n + '"]');
    if (!recap) return;
    recap.hidden = !visible;
    var val = recap.querySelector('[data-f2-recap-value="' + n + '"]');
    if (val) val.textContent = valueText || '';
  };

  Widget.prototype.contactRecap = function () {
    var name = [this.val('firstName'), this.val('lastName')].filter(Boolean).join(' ');
    var parts = [name, this.val('email'), this.val('phone')].filter(Boolean);
    return parts.join(' · ');
  };

  Widget.prototype.deliveryRecap = function () {
    if (!this.methodSelected()) return '';
    var label = METHOD_LABELS[this.state.courier + ':' + this.state.service] || '';
    var detail = '';
    if (this.state.service === 'office') detail = this.state.officeLabel || '';
    else if (this.state.service === 'address') {
      if (this.state.addrFallback) {
        detail = [this.val('fb_city'), this.val('fb_address1')].filter(Boolean).join(', ');
      } else {
        var street = (this.state.addrStreetType ? this.state.addrStreetType + ' ' : '') + (this.state.addrStreetName || '');
        var recapNo = this.val('addr_no');
        var recapAddr = (street + (recapNo ? ' №' + recapNo : '')).trim();
        detail = [this.state.addrSiteName, recapAddr].filter(Boolean).join(', ');
      }
    }
    return detail ? label + ' — ' + detail : label;
  };

  /* ---- Прихващане на стандартния checkout ---- */

  Widget.prototype.bindCheckoutInterception = function () {
    var self = this;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('button[name="checkout"]') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (self.isCartPageNode(btn)) self.openPopup();
      else window.location.href = '/cart';
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.id === 'cart') {
        e.preventDefault();
        e.stopPropagation();
        self.openPopup();
      }
    }, true);
  };

  Widget.prototype.isCartPageNode = function (node) {
    return !!(node.closest('cart-items') || node.closest('#main-cart-items') ||
      node.closest('#cart') || node.closest('.cart-page-column'));
  };

  /* ---- Отваряне/затваряне ---- */

  Widget.prototype.bindPopupControls = function () {
    var self = this;
    this.overlay.addEventListener('click', function () { self.closePopup(); });
    var closeBtn = this.root.querySelector('[data-f2-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { self.closePopup(); });
    document.addEventListener('keydown', function (e) {
      if (!self.state.open) return;
      if (e.key === 'Escape') { e.preventDefault(); self.closePopup(); return; }
      if (e.key === 'Tab') self.trapFocus(e);
    });

    if (this.backBtn) this.backBtn.addEventListener('click', function () { self.back(); });

    // Клавиатура/лента на браузъра сменят видимата височина И offsetTop →
    // пресинхронизирай и при resize, и при scroll на visual viewport-а.
    if (window.visualViewport) {
      var onViewport = function () { if (self.state.open) self.syncViewportHeight(); };
      window.visualViewport.addEventListener('resize', onViewport);
      window.visualViewport.addEventListener('scroll', onViewport);
    }

    // Рейл + свити обобщения → връщане към стъпка.
    this.root.addEventListener('click', function (e) {
      var goBtn = e.target && e.target.closest ? e.target.closest('[data-f2-goto]') : null;
      if (goBtn && self.root.contains(goBtn)) {
        var n = parseInt(goBtn.getAttribute('data-f2-goto'), 10);
        if (n) { e.preventDefault(); self.railGoto(n); }
      }
    });
  };

  Widget.prototype.openPopup = function () {
    if (this.state.open) return;
    this.state.open = true;
    this.state.lastFocus = document.activeElement;
    this.root.hidden = false;
    this.overlay.hidden = false;
    this.dialog.hidden = false;
    document.documentElement.classList.add('marmot-f2-open');
    this.syncViewportHeight();
    this.goToStep(1);
    this.loadCart();
  };

  // Мобилно: свива диалога до видимата височина (visualViewport), за да остане
  // лепнатият футър и основният бутон над клавиатурата/лентата на браузъра.
  Widget.prototype.syncViewportHeight = function () {
    if (!this.dialog) return;
    var vv = window.visualViewport;
    if (vv && window.innerWidth < 768) {
      // Свиваме диалога до видимата височина И го местим с offsetTop-а на visual
      // viewport-а. На iOS клавиатурата не свива layout viewport-а, а мести
      // visible областта → без translateY лепнатият футър остава ПОД клавиатурата.
      this.dialog.style.height = Math.round(vv.height) + 'px';
      this.dialog.style.transform = 'translateY(' + Math.round(vv.offsetTop) + 'px)';
    } else {
      this.dialog.style.height = '';
      this.dialog.style.transform = '';
    }
  };

  Widget.prototype.closePopup = function () {
    if (!this.state.open) return;
    this.state.open = false;
    this.overlay.hidden = true;
    this.dialog.hidden = true;
    this.root.hidden = true;
    document.documentElement.classList.remove('marmot-f2-open');
    if (this.dialog) { this.dialog.style.height = ''; this.dialog.style.transform = ''; }
    this.hideAllLists();
    if (this.state.lastFocus && this.state.lastFocus.focus) this.state.lastFocus.focus();
  };

  Widget.prototype.trapFocus = function (e) {
    var focusables = this.dialog.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    var visible = Array.prototype.filter.call(focusables, function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!visible.length) return;
    var first = visible[0];
    var last = visible[visible.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  /* ---- Количка + обобщение ---- */

  Widget.prototype.loadCart = function () {
    var self = this;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { self.state.cart = cart; self.updateSummary(); })
      .catch(function () { /* обобщението остава с тирета */ });
  };

  Widget.prototype.cartSubtotalCents = function () {
    var cart = this.state.cart;
    if (!cart || !cart.items) return null;
    return cart.items.reduce(function (sum, it) { return sum + (it.final_line_price || 0); }, 0);
  };

  Widget.prototype.cartItemCount = function () {
    var cart = this.state.cart;
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (n, it) { return n + (it.quantity || 0); }, 0);
  };

  Widget.prototype.selectedMethodPriceEur = function () {
    if (!this.methodSelected()) return null;
    var key = this.state.courier + ':' + this.state.service;
    var m = (this.cfg.methods || []).filter(function (x) { return (x.courier + ':' + x.service) === key; })[0];
    return m ? (m.priceEur || 0) : null;
  };

  Widget.prototype.renderCartLines = function () {
    var box = this.linesBox;
    if (!box) return;
    box.innerHTML = '';
    var cart = this.state.cart;
    if (!cart || !cart.items) return;
    cart.items.forEach(function (it) {
      var row = document.createElement('div');
      row.className = 'marmot-f2__line';
      var name = document.createElement('span');
      name.className = 'marmot-f2__line-name';
      name.textContent = (it.product_title || it.title) + (it.quantity > 1 ? ' × ' + it.quantity : '');
      var price = document.createElement('span');
      price.className = 'marmot-f2__line-price';
      price.textContent = L.money(it.final_line_price);
      row.appendChild(name);
      row.appendChild(price);
      box.appendChild(row);
    });
  };

  Widget.prototype.updateSummary = function () {
    this.renderCartLines();
    this.applyItemsOpen();

    var subtotal = this.cartSubtotalCents();
    var priceEur = this.selectedMethodPriceEur();
    var totals = L.computeTotals({ subtotalCents: subtotal, methodPriceEur: priceEur, cfg: this.cfg });

    // При достигнат праг всички методи стават безплатни — отрази го на картите.
    this.updateMethodPrices(subtotal != null && L.isFreeShipping(subtotal, this.cfg));

    setText(this.root, '[data-f2-subtotal]', subtotal == null ? '—' : L.money(subtotal));
    setText(this.root, '[data-f2-shipping]', totals.shippingCents == null ? '—' : (totals.isFree ? 'Безплатно' : L.money(totals.shippingCents)));
    setText(this.root, '[data-f2-total]', totals.totalCents == null ? '—' : L.money(totals.totalCents));

    // Брояч на артикулите в toggle-а.
    var count = this.cartItemCount();
    var countTxt = count ? count + ' ' + plural(count, 'артикул', 'артикула', 'артикула') + (subtotal != null ? ' · ' + L.money(subtotal, false) : '') : 'Артикули';
    setText(this.root, '[data-f2-items-count]', countTxt);

    // Прогрес до безплатна доставка (видим от стъпка 1).
    var prog = L.freeShipProgress(subtotal, this.cfg);
    var free = this.root.querySelector('[data-f2-freeship]');
    if (free) {
      free.hidden = !prog.show;
      if (prog.show) {
        // Редът с остатъка НЕ влачи „(преди отстъпки)" — уточнението стои само
        // там, където се обявява самото правило с числото (решение 09.08.2026).
        setText(this.root, '[data-f2-freeship-text]', 'Още ' + L.money(prog.remainingCents, false) + ' до безплатна доставка');
        var fill = this.root.querySelector('[data-f2-freeship-fill]');
        if (fill) fill.style.width = prog.percent + '%';
      }
    }

    if (this.state.step === 3) this.updateReview();
  };

  Widget.prototype.updateReview = function () {
    var subtotal = this.cartSubtotalCents();
    var priceEur = this.selectedMethodPriceEur();
    var totals = L.computeTotals({ subtotalCents: subtotal, methodPriceEur: priceEur, cfg: this.cfg });
    var count = this.cartItemCount();
    setText(this.root, '[data-f2-rev-items]', count ? count + ' ' + plural(count, 'книга', 'книги', 'книги') : 'Книги');
    setText(this.root, '[data-f2-rev-sub]', subtotal == null ? '—' : L.money(subtotal));
    setText(this.root, '[data-f2-rev-method]', this.methodSelected() ? (METHOD_LABELS[this.state.courier + ':' + this.state.service] || 'Доставка') : 'Доставка');
    setText(this.root, '[data-f2-rev-ship]', totals.shippingCents == null ? '—' : (totals.isFree ? 'Безплатно' : L.money(totals.shippingCents)));
    setText(this.root, '[data-f2-rev-total]', totals.totalCents == null ? '—' : L.money(totals.totalCents));
  };

  Widget.prototype.applyItemsOpen = function () {
    if (this.linesBox) this.linesBox.hidden = !this.state.itemsOpen;
    if (this.itemsToggle) this.itemsToggle.setAttribute('aria-expanded', this.state.itemsOpen ? 'true' : 'false');
    setText(this.root, '[data-f2-items-caret]', this.state.itemsOpen ? '▴' : '▾');
  };

  /* ---- Форма: фактура, промо, търсене на офис ---- */

  Widget.prototype.bindFormBehaviour = function () {
    var self = this;

    var invoiceToggle = this.root.querySelector('[data-f2-invoice-toggle]');
    var invoiceFields = this.root.querySelector('[data-f2-invoice-fields]');
    if (invoiceToggle && invoiceFields) {
      invoiceToggle.addEventListener('change', function () {
        invoiceFields.hidden = !invoiceToggle.checked;
      });
    }

    if (this.itemsToggle) {
      this.itemsToggle.addEventListener('click', function () {
        self.state.itemsOpen = !self.state.itemsOpen;
        self.applyItemsOpen();
      });
    }

    var promoApply = this.root.querySelector('[data-f2-promo-apply]');
    var promoInput = this.root.querySelector('#marmot-f2-promo');
    var promoNote = this.root.querySelector('[data-f2-promo-note]');
    function hidePromoNote() {
      if (!promoNote) return;
      promoNote.hidden = true;
      promoNote.textContent = '';
    }
    function applyPromo() {
      var note = L.promoNote(promoInput.value);
      self.state.promo = note ? note.code : '';
      if (!promoNote) return;
      promoNote.hidden = !note;
      promoNote.textContent = note ? note.text : '';
    }
    if (promoApply && promoInput) {
      promoApply.addEventListener('click', applyPromo);
      // Enter в промо полето прилага кода, а не подава формата (не сменя стъпка).
      promoInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); applyPromo(); }
      });
      // Инвариант: бележката се вижда ТОЧНО когато кодът в полето е приложен и
      // ще пътува към draft-а. Всяка редакция без ново „Приложи" анулира и
      // двете – иначе на клиента остава ред за код, който вече не е в полето,
      // или стар код тръгва към чекаута незабелязано.
      promoInput.addEventListener('input', function () {
        var current = L.promoNote(promoInput.value);
        var currentCode = current ? current.code : '';
        if (currentCode !== self.state.promo) {
          self.state.promo = '';
          hidePromoNote();
        }
      });
    }

    if (this.cityInput) {
      this.cityInput.addEventListener('input', function () { self.onCityInput(); });
      this.cityInput.addEventListener('keydown', function (e) { self.onListKeydown(e, self.cityList); });
      this.cityInput.addEventListener('focus', function () {
        if (self.cityList && self.cityList.children.length) self.showList(self.cityList, self.cityInput);
      });
    }
    if (this.officeInput) {
      this.officeInput.addEventListener('input', function () { self.onOfficeInput(); });
      this.officeInput.addEventListener('keydown', function (e) { self.onListKeydown(e, self.officeList); });
      this.officeInput.addEventListener('focus', function () {
        if (self.officeList && self.officeList.children.length) self.showList(self.officeList, self.officeInput);
      });
    }
    // Град за „До личен адрес" (Speedy номенклатура).
    if (this.addrCityInput) {
      this.addrCityInput.addEventListener('input', function () { self.onAddrCityInput(); });
      this.addrCityInput.addEventListener('keydown', function (e) { self.onListKeydown(e, self.addrCityList); });
      this.addrCityInput.addEventListener('focus', function () {
        if (self.addrCityList && self.addrCityList.children.length) self.showList(self.addrCityList, self.addrCityInput);
      });
    }
    // Улица за „До личен адрес".
    if (this.addrStreetInput) {
      this.addrStreetInput.addEventListener('input', function () { self.onAddrStreetInput(); });
      this.addrStreetInput.addEventListener('keydown', function (e) { self.onListKeydown(e, self.addrStreetList); });
      this.addrStreetInput.addEventListener('focus', function () {
        if (self.addrStreetList && self.addrStreetList.children.length) self.showList(self.addrStreetList, self.addrStreetInput);
      });
    }
    // Клик извън полетата с падащи списъци ги затваря.
    document.addEventListener('click', function (e) {
      var inOffice = self.officeBox && self.officeBox.contains(e.target);
      var inAddr = self.addressBox && self.addressBox.contains(e.target);
      if (!inOffice && !inAddr) self.hideAllLists();
    });

    // При фокус скролваме полето във видимото (в скролващия контейнер на модала).
    // Поле с падащ списък (град/улица/офис, role=combobox) → в ГОРНАТА част
    // (block:'start' + scroll-padding-top), за да има място списъкът да се отвори
    // цял под него; и на десктоп. Обикновено поле → център, само на мобилен, за
    // да не остане под клавиатурата/лепнатия футър.
    this.form.addEventListener('focusin', function (e) {
      var target = e.target;
      if (!target || !target.scrollIntoView) return;
      var isCombo = target.getAttribute && target.getAttribute('role') === 'combobox';
      if (isCombo) {
        setTimeout(function () {
          try { target.scrollIntoView({ block: 'start' }); } catch (err) {}
        }, 250);
      } else if (window.innerWidth < 768) {
        setTimeout(function () {
          try { target.scrollIntoView({ block: 'center' }); } catch (err) {}
        }, 300);
      }
    });

    // Единственият вход напред: submit на формата (CTA бутонът или Enter).
    this.form.addEventListener('submit', function (e) { e.preventDefault(); self.advance(); });
  };

  /* Град: пишеш → избираш от списък (град + пощенски код). Смяната на града
     нулира избрания офис и крие офис полето. */
  Widget.prototype.onCityInput = function () {
    var self = this;
    this.clearError('officeCity');
    this.state.cityName = null;
    this.state.cityZip = null;
    this.state.officeId = null;
    this.cityOffices = [];
    this.cityOfficesTruncated = false;
    if (this.officeHint) this.officeHint.hidden = true;
    if (this.officeField) this.officeField.hidden = true;
    if (this.officeInput) this.officeInput.value = '';
    this.hideList(this.officeList, this.officeInput);
    var q = this.cityInput.value.trim();
    clearTimeout(this.officeSearchTimer);
    if (q.replace(/\s/g, '').length < 2) { this.hideList(this.cityList, this.cityInput); return; }
    this.officeSearchTimer = setTimeout(function () { self.searchCities(q); }, 250);
  };

  Widget.prototype.searchCities = function (q) {
    var self = this;
    var courier = this.state.courier;
    if (!courier) return;
    var seq = ++this.officeSearchSeq;
    var url = this.apiBase + '/api/shopify/checkout/offices?courier=' + encodeURIComponent(courier) +
      '&q=' + encodeURIComponent(q) + '&limit=20';
    apiGet(url).then(function (res) {
      if (seq !== self.officeSearchSeq) return; // изпреварен от по-нов упит
      self.renderCities(L.distinctCities((res && res.offices) || []));
    }).catch(function () { self.renderCities([]); });
  };

  Widget.prototype.renderCities = function (cities) {
    var self = this;
    this.cityList.innerHTML = '';
    if (!cities.length) {
      this.cityList.appendChild(emptyLi('Няма намерен град. Провери изписването.'));
      this.showList(this.cityList, this.cityInput);
      return;
    }
    cities.forEach(function (c) {
      var li = document.createElement('li');
      li.className = 'marmot-f2__office-item marmot-f2__office-item--row';
      li.setAttribute('role', 'option');
      li.innerHTML = '<span class="marmot-f2__office-name">' + escapeHtml(c.city) + '</span>' +
        (c.zip ? '<span class="marmot-f2__office-zip">' + escapeHtml(c.zip) + '</span>' : '');
      li.addEventListener('click', function () { self.chooseCity(c); });
      self.cityList.appendChild(li);
    });
    this.showList(this.cityList, this.cityInput);
  };

  Widget.prototype.chooseCity = function (c) {
    clearTimeout(this.officeSearchTimer); // спри чакащ упит да не преотвори списъка след избора
    this.state.cityName = c.city;
    this.state.cityZip = c.zip || null;
    this.state.officeId = null;
    this.cityInput.value = c.city + (c.zip ? ' (' + c.zip + ')' : '');
    this.hideList(this.cityList, this.cityInput);
    this.clearError('officeCity');
    if (this.officeField) this.officeField.hidden = false;
    if (this.officeInput) this.officeInput.value = '';
    this.loadCityOffices(c);
    if (this.officeInput) { try { this.officeInput.focus(); } catch (e) {} }
    this.updateStepUI();
  };

  // Зарежда ВСИЧКИ офиси в избрания град (един упит, филтрира по град+zip).
  // limit=CITY_OFFICE_LIMIT, не 20: София има стотици офиса и автомата и при
  // таван 20 списъкът свършваше по средата на азбуката — изглеждаше като
  // липсваща база (телефонен тест 26.07).
  Widget.prototype.loadCityOffices = function (c) {
    var self = this;
    var courier = this.state.courier;
    if (!courier) return;
    var seq = ++this.officeSearchSeq;
    var url = this.apiBase + '/api/shopify/checkout/offices?courier=' + encodeURIComponent(courier) +
      '&q=' + encodeURIComponent(c.city) + '&limit=' + CITY_OFFICE_LIMIT;
    apiGet(url).then(function (res) {
      if (seq !== self.officeSearchSeq) return;
      var all = (res && res.offices) || [];
      self.cityOffices = all.filter(function (o) {
        return (o.city || '') === c.city && (!c.zip || (o.zip || '') === c.zip);
      });
      // Сървърът казва колко е намерил ПРЕДИ отрязването; ако е орязал, го
      // казваме на човека, вместо да го оставим да мисли, че това са всички.
      var total = typeof (res && res.total) === 'number' ? res.total : all.length;
      self.cityOfficesTruncated = total > all.length;
      self.renderOffices(self.cityOffices);
    }).catch(function () { self.cityOffices = []; self.renderOffices([]); });
  };

  // Офис в града: филтрира client-side из вече заредените офиси.
  Widget.prototype.onOfficeInput = function () {
    this.clearError('office');
    this.state.officeId = null;
    var q = this.officeInput.value.trim().toLowerCase();
    var list = this.cityOffices.filter(function (o) {
      return !q || ((o.name || '') + ' ' + (o.address || '')).toLowerCase().indexOf(q) >= 0;
    });
    this.renderOffices(list);
  };

  // Честен ред под полето: колко офиса има градът и колко виждаш сега.
  Widget.prototype.updateOfficeHint = function (shown) {
    if (!this.officeHint) return;
    var total = this.cityOffices.length;
    if (!total) { this.officeHint.hidden = true; return; }
    var text;
    if (this.cityOfficesTruncated) {
      text = 'Показани са първите ' + total + ' в града — пиши, за да стесниш търсенето.';
    } else if (shown < total) {
      text = 'Показани ' + shown + ' от ' + total + ' в града.';
    } else if (total === 1) {
      text = '1 офис в града.';
    } else {
      text = total + ' офиса и автомата в града — пиши, за да търсиш.';
    }
    this.officeHint.textContent = text;
    this.officeHint.hidden = false;
  };

  Widget.prototype.renderOffices = function (offices) {
    var self = this;
    this.officeList.innerHTML = '';
    this.updateOfficeHint(offices.length);
    if (!offices.length) {
      this.officeList.appendChild(emptyLi('Няма офис в този град по това търсене.'));
      this.showList(this.officeList, this.officeInput);
      return;
    }
    offices.forEach(function (o) {
      var li = document.createElement('li');
      li.className = 'marmot-f2__office-item';
      li.setAttribute('role', 'option');
      var typeTag = o.type === 'locker' ? '<span class="marmot-f2__office-tag">автомат</span>' : '';
      li.innerHTML =
        '<span class="marmot-f2__office-name">' + escapeHtml(o.name || '') + typeTag + '</span>' +
        '<span class="marmot-f2__office-addr">' + escapeHtml(o.address || '') + '</span>';
      li.addEventListener('click', function () { self.chooseOffice(o); });
      self.officeList.appendChild(li);
    });
    this.showList(this.officeList, this.officeInput);
  };

  Widget.prototype.chooseOffice = function (o) {
    this.state.officeId = String(o.externalId);
    this.state.officeType = o.type || null;
    this.state.officeLabel = [o.name, o.city, o.address].filter(Boolean).join(' · ');
    this.officeInput.value = o.name + (o.type === 'locker' ? ' (автомат)' : '');
    this.hideList(this.officeList, this.officeInput);
    this.clearError('office');
    this.updateStepUI(); // обнови свитото обобщение на доставката
  };

  /* ---- „До личен адрес" (само Speedy): град + улица от номенклатурата ---- */

  /* Град: пишеш → избираш от списък (град + пощенски код за ориентир). Смяната
     на града нулира улицата и детайлите — улицата зависи от site id. */
  Widget.prototype.onAddrCityInput = function () {
    var self = this;
    this.clearError('addrCity');
    this.state.addrSiteId = null;
    this.state.addrSiteName = null;
    this.state.addrZip = null;
    this.resetAddrStreet();
    var q = this.addrCityInput.value.trim();
    clearTimeout(this.addrCityTimer);
    if (q.replace(/\s/g, '').length < 2) { this.hideList(this.addrCityList, this.addrCityInput); return; }
    this.addrCityTimer = setTimeout(function () { self.searchAddrCities(q); }, 300);
  };

  Widget.prototype.searchAddrCities = function (q) {
    var self = this;
    var seq = ++this.addrCitySeq;
    var url = this.apiBase + '/api/shopify/checkout/sites?store=' + encodeURIComponent(this.store) +
      '&q=' + encodeURIComponent(q) + '&limit=20';
    apiGet(url).then(function (res) {
      if (seq !== self.addrCitySeq) return; // изпреварен от по-нов упит
      // Само реален отказ от Спиди (сигнал от сървъра) пали резервния път —
      // не клиентски network error, не празен резултат (= „няма такъв град").
      if (res && res.error === 'COURIER_UNAVAILABLE') { self.enterAddrFallback(); return; }
      self.renderAddrCities((res && res.sites) || []);
    }).catch(function () { self.renderAddrCities([]); });
  };

  Widget.prototype.renderAddrCities = function (sites) {
    var self = this;
    this.addrCityList.innerHTML = '';
    if (!sites.length) {
      this.addrCityList.appendChild(emptyLi('Няма намерено населено място. Провери изписването.'));
      this.showList(this.addrCityList, this.addrCityInput);
      return;
    }
    sites.forEach(function (s) {
      var li = document.createElement('li');
      li.className = 'marmot-f2__office-item marmot-f2__office-item--row';
      li.setAttribute('role', 'option');
      var nameHtml = escapeHtml(s.name) +
        (s.region ? ' <span class="marmot-f2__office-region">· ' + escapeHtml(s.region) + '</span>' : '');
      li.innerHTML = '<span class="marmot-f2__office-name">' + nameHtml + '</span>' +
        (s.postCode ? '<span class="marmot-f2__office-zip">' + escapeHtml(s.postCode) + '</span>' : '');
      li.addEventListener('click', function () { self.chooseAddrCity(s); });
      self.addrCityList.appendChild(li);
    });
    this.showList(this.addrCityList, this.addrCityInput);
  };

  Widget.prototype.chooseAddrCity = function (s) {
    clearTimeout(this.addrCityTimer); // спри чакащ упит да не преотвори списъка след избора
    this.addrCitySeq++;               // обезсили упит „в полет"
    this.state.addrSiteId = s.siteId;
    this.state.addrSiteName = s.name;
    this.state.addrZip = s.postCode || null;
    this.addrCityInput.value = s.name + (s.postCode ? ' (' + s.postCode + ')' : '');
    this.hideList(this.addrCityList, this.addrCityInput);
    this.clearError('addrCity');
    this.resetAddrStreet();
    if (this.addrStreetField) this.addrStreetField.hidden = false;
    if (this.addrStreetInput) { try { this.addrStreetInput.focus(); } catch (e) {} }
    this.updateStepUI();
  };

  // Нулира улицата + детайлите (при смяна на града или на метода).
  Widget.prototype.resetAddrStreet = function () {
    this.state.addrStreetId = null;
    this.state.addrStreetName = null;
    this.state.addrStreetType = null;
    if (this.addrStreetInput) this.addrStreetInput.value = '';
    if (this.addrStreetField) this.addrStreetField.hidden = true;
    if (this.addrDetails) this.addrDetails.hidden = true;
    this.hideList(this.addrStreetList, this.addrStreetInput);
    this.clearError('addrStreet');
    this.clearError('addrNo');
  };

  /* Улица: пишеш → избираш от номенклатурата на Спиди за избрания град. */
  Widget.prototype.onAddrStreetInput = function () {
    var self = this;
    this.clearError('addrStreet');
    this.state.addrStreetId = null;
    this.state.addrStreetName = null;
    this.state.addrStreetType = null;
    if (this.addrDetails) this.addrDetails.hidden = true;
    if (!this.state.addrSiteId) { this.hideList(this.addrStreetList, this.addrStreetInput); return; }
    var q = this.addrStreetInput.value.trim();
    clearTimeout(this.addrStreetTimer);
    if (q.replace(/\s/g, '').length < 2) { this.hideList(this.addrStreetList, this.addrStreetInput); return; }
    this.addrStreetTimer = setTimeout(function () { self.searchAddrStreets(q); }, 300);
  };

  Widget.prototype.searchAddrStreets = function (q) {
    var self = this;
    if (!this.state.addrSiteId) return;
    var seq = ++this.addrStreetSeq;
    var url = this.apiBase + '/api/shopify/checkout/streets?store=' + encodeURIComponent(this.store) +
      '&siteId=' + encodeURIComponent(this.state.addrSiteId) +
      '&q=' + encodeURIComponent(q) + '&limit=20';
    apiGet(url).then(function (res) {
      if (seq !== self.addrStreetSeq) return;
      if (res && res.error === 'COURIER_UNAVAILABLE') { self.enterAddrFallback(); return; }
      self.renderAddrStreets((res && res.streets) || []);
    }).catch(function () { self.renderAddrStreets([]); });
  };

  Widget.prototype.renderAddrStreets = function (streets) {
    var self = this;
    this.addrStreetList.innerHTML = '';
    if (!streets.length) {
      this.addrStreetList.appendChild(emptyLi('Няма намерена улица. Провери изписването или града.'));
      this.showList(this.addrStreetList, this.addrStreetInput);
      return;
    }
    streets.forEach(function (st) {
      var li = document.createElement('li');
      li.className = 'marmot-f2__office-item';
      li.setAttribute('role', 'option');
      var typ = st.type ? '<span class="marmot-f2__office-region">' + escapeHtml(st.type) + '</span> ' : '';
      li.innerHTML = '<span class="marmot-f2__office-name">' + typ + escapeHtml(st.name) + '</span>';
      li.addEventListener('click', function () { self.chooseAddrStreet(st); });
      self.addrStreetList.appendChild(li);
    });
    this.showList(this.addrStreetList, this.addrStreetInput);
  };

  Widget.prototype.chooseAddrStreet = function (st) {
    clearTimeout(this.addrStreetTimer); // спри чакащ упит да не преотвори списъка след избора
    this.addrStreetSeq++;               // обезсили упит „в полет"
    this.state.addrStreetId = st.streetId;
    this.state.addrStreetName = st.name;
    this.state.addrStreetType = st.type || null;
    this.addrStreetInput.value = (st.type ? st.type + ' ' : '') + st.name;
    this.hideList(this.addrStreetList, this.addrStreetInput);
    this.clearError('addrStreet');
    if (this.addrDetails) this.addrDetails.hidden = false;
    var no = this.root.querySelector('[data-f2-addr-no]');
    if (no) { try { no.focus(); } catch (e) {} }
    this.updateStepUI();
  };

  // Пълно нулиране на адресните полета (при смяна на метода на доставка).
  Widget.prototype.clearAddressUI = function () {
    this.state.addrSiteId = null;
    this.state.addrSiteName = null;
    this.state.addrZip = null;
    this.state.addrFallback = false;
    this.resetAddrStreet();
    if (this.addrCityInput) this.addrCityInput.value = '';
    var self = this;
    ['addr_no', 'addr_block', 'addr_entrance', 'addr_floor', 'addr_apt',
      'fb_city', 'fb_zip', 'fb_address1'].forEach(function (n) {
      var el = self.form.querySelector('[name="' + n + '"]');
      if (el) el.value = '';
    });
    // Върни номенклатурния поток, скрий резервния.
    if (this.addrLookup) this.addrLookup.hidden = false;
    if (this.addrFallbackBox) this.addrFallbackBox.hidden = true;
    this.hideList(this.addrCityList, this.addrCityInput);
    this.clearError('addrCity');
    this.clearError('fbCity');
    this.clearError('fbZip');
    this.clearError('fbAddress1');
  };

  /* Резервен път: показва се САМО когато сървърът каже COURIER_UNAVAILABLE (Спиди
     API-то е недостъпно), НЕ като бутон и НЕ при празен резултат. Пренася вече
     въведения град, за да не се губи. Оттук нататък адресът е свободен текст и
     поръчката ще носи белег „Непроверен адрес" (виж buildRequest). */
  Widget.prototype.enterAddrFallback = function () {
    if (this.state.addrFallback) return;
    this.state.addrFallback = true;
    this.state.addrSiteId = null;
    this.state.addrStreetId = null;
    this.hideAllLists();
    if (this.addrLookup) this.addrLookup.hidden = true;
    if (this.addrFallbackBox) this.addrFallbackBox.hidden = false;
    // Пренеси въведения град (без „(1000)" наставката) в свободното поле.
    var fbCity = this.form.querySelector('[name="fb_city"]');
    if (fbCity && !fbCity.value) {
      var typed = this.state.addrSiteName ||
        (this.addrCityInput ? this.addrCityInput.value.replace(/\s*\(\d+\)\s*$/, '').trim() : '');
      if (typed) fbCity.value = typed;
    }
    var fbZip = this.form.querySelector('[name="fb_zip"]');
    if (fbZip && !fbZip.value && this.state.addrZip) fbZip.value = this.state.addrZip;
    this.updateStepUI();
  };

  // Клавиатура в списък (град или офис): стрелки местят, Enter избира и НЕ подава формата.
  Widget.prototype.onListKeydown = function (e, listEl) {
    if (!listEl) return;
    var items = listEl.querySelectorAll('.marmot-f2__office-item');
    if (e.key === 'Enter') {
      e.preventDefault();
      var active = listEl.querySelector('.marmot-f2__office-item.is-active');
      if (active) active.click();
      return;
    }
    if (!items.length) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      var idx = -1;
      for (var i = 0; i < items.length; i++) { if (items[i].classList.contains('is-active')) { idx = i; break; } }
      var dir = e.key === 'ArrowDown' ? 1 : -1;
      idx = (idx + dir + items.length) % items.length;
      for (var j = 0; j < items.length; j++) items[j].classList.toggle('is-active', j === idx);
      items[idx].scrollIntoView({ block: 'nearest' });
    }
  };

  /* ---- Валидация + подаване ---- */

  Widget.prototype.val = function (name) {
    var el = this.form.querySelector('[name="' + name + '"]');
    return el ? el.value.trim() : '';
  };

  // Валидира само полетата на дадена стъпка (per-step, за да не пуска напред с грешни данни).
  Widget.prototype.validateStep = function (step) {
    var e = {};
    if (step === 1) {
      if (!this.val('firstName')) e.firstName = 'Въведи име.';
      if (!this.val('lastName')) e.lastName = 'Въведи фамилия.';
      var email = this.val('email');
      if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) e.email = 'Въведи валиден имейл.';
      if (!L.normalizePhone(this.val('phone'))) e.phone = 'Въведи валиден български телефон.';
      var invoiceToggle = this.root.querySelector('[data-f2-invoice-toggle]');
      if (invoiceToggle && invoiceToggle.checked) {
        if (!this.val('company_name')) e.company_name = 'Въведи фирма.';
        if (!this.val('uic')) e.uic = 'Въведи ЕИК.';
        if (!this.val('vat')) e.vat = 'Въведи ДДС номер.';
        if (!this.val('company_address')) e.company_address = 'Въведи адрес на фирмата.';
      }
    } else if (step === 2) {
      if (!this.methodSelected()) e.method = 'Избери метод на доставка.';
      else if (this.state.service === 'office') {
        if (!this.state.cityName) e.officeCity = 'Избери град от списъка.';
        else if (!this.state.officeId) e.office = 'Избери офис от списъка.';
      }
      else if (this.state.service === 'address') {
        if (this.state.addrFallback) {
          if (!this.val('fb_city')) e.fbCity = 'Въведи град.';
          if (!this.val('fb_zip')) e.fbZip = 'Въведи пощенски код.';
          if (this.val('fb_address1').length < 6) e.fbAddress1 = 'Въведи пълен адрес.';
        } else {
          if (!this.state.addrSiteId) e.addrCity = 'Избери град от списъка.';
          else if (!this.state.addrStreetId) e.addrStreet = 'Избери улица от списъка.';
          else if (!this.val('addr_no')) e.addrNo = 'Въведи номер.';
        }
      }
    } else if (step === 3) {
      var terms = this.root.querySelector('[data-f2-terms]');
      if (!terms || !terms.checked) e.terms = 'Приеми общите условия.';
    }
    return e;
  };

  // Показва грешките; връща true, ако е имало (и не бива да се продължава).
  Widget.prototype.showErrors = function (errors) {
    var names = Object.keys(errors);
    if (!names.length) return false;
    for (var i = 0; i < names.length; i++) this.setError(names[i], errors[names[i]]);
    var firstField = this.form.querySelector('[data-f2-error="' + names[0] + '"]');
    if (firstField && firstField.previousElementSibling && firstField.previousElementSibling.focus) {
      try { firstField.previousElementSibling.focus(); } catch (e) {}
    }
    return true;
  };

  Widget.prototype.submit = function () {
    if (this.state.submitting) return;
    this.clearAllErrors();
    // Защитно: пълна валидация на всичките три стъпки преди draft.
    var all = {};
    for (var s = 1; s <= 3; s++) {
      var errs = this.validateStep(s);
      for (var k in errs) all[k] = errs[k];
    }
    if (Object.keys(all).length) {
      // Върни на първата стъпка с грешка, за да я поправи.
      var order = ['firstName', 'lastName', 'email', 'phone', 'company_name', 'uic', 'vat', 'company_address', 'method', 'officeCity', 'office', 'addrCity', 'addrStreet', 'addrNo', 'fbCity', 'fbZip', 'fbAddress1', 'terms'];
      var firstStep = 3;
      var stepOfField = { firstName: 1, lastName: 1, email: 1, phone: 1, company_name: 1, uic: 1, vat: 1, company_address: 1, method: 2, officeCity: 2, office: 2, addrCity: 2, addrStreet: 2, addrNo: 2, fbCity: 2, fbZip: 2, fbAddress1: 2, terms: 3 };
      for (var j = 0; j < order.length; j++) { if (all[order[j]]) { firstStep = stepOfField[order[j]]; break; } }
      if (firstStep !== this.state.step) this.goToStep(firstStep);
      this.showErrors(all);
      return;
    }

    var body = this.buildRequest();
    this.setSubmitting(true);
    this.postDraft(body, true);
  };

  Widget.prototype.postDraft = function (body, allowKeyRetry) {
    var self = this;
    if (!this.state.idempotencyKey) this.state.idempotencyKey = uuid();
    apiPost(this.apiBase + '/api/shopify/checkout/draft', body, {
      'Idempotency-Key': this.state.idempotencyKey
    }).then(function (res) {
      if (res && res.invoiceUrl) {
        if (self.ctaLabel) self.ctaLabel.textContent = 'Пренасочваме…';
        window.location.href = res.invoiceUrl;
        return;
      }
      self.setSubmitting(false);
      self.showFormError(ERROR_MESSAGES.SERVER_ERROR);
    }).catch(function (err) {
      if (err && err.code === 'IDEMPOTENCY_CONFLICT' && allowKeyRetry) {
        self.state.idempotencyKey = uuid();
        self.postDraft(body, false);
        return;
      }
      self.setSubmitting(false);
      var msg = (err && err.code && ERROR_MESSAGES[err.code]) ||
        (err && err.network ? ERROR_MESSAGES.NETWORK : null) ||
        (err && err.rateLimited ? ERROR_MESSAGES.RATE_LIMITED : null) ||
        ERROR_MESSAGES.SERVER_ERROR;
      self.showFormError(msg);
    });
  };

  /* ---- Draft заявка — НЕ се пипа (контрактът срещу #D774) ---- */
  Widget.prototype.buildRequest = function () {
    var cart = this.state.cart || { items: [], attributes: {} };
    var lines = (cart.items || []).map(function (it) {
      return {
        variant_id: it.variant_id || it.id,
        quantity: it.quantity,
        final_price: it.final_price,
        final_line_price: it.final_line_price,
        title: it.title,
        properties: it.properties && Object.keys(it.properties).length ? it.properties : undefined
      };
    });
    var invoiceToggle = this.root.querySelector('[data-f2-invoice-toggle]');
    var invoiceRequested = !!(invoiceToggle && invoiceToggle.checked);

    var body = {
      store: this.store,
      lines: lines,
      attributes: cart.attributes && Object.keys(cart.attributes).length ? cart.attributes : undefined,
      discountCodes: readCartDiscountCodes(cart),
      promoCode: this.state.promo || undefined,
      firstName: this.val('firstName'),
      lastName: this.val('lastName'),
      email: this.val('email'),
      phone: L.normalizePhone(this.val('phone')),
      invoiceRequested: invoiceRequested,
      courier: this.state.courier,
      service: this.state.service,
      acceptedTerms: true,
      widgetConfigVersion: CONFIG_VERSION
    };
    if (invoiceRequested) {
      body.company_name = this.val('company_name');
      body.uic = this.val('uic');
      body.vat = this.val('vat');
      body.company_address = this.val('company_address');
    }
    if (this.state.service === 'office') {
      body.officeId = this.state.officeId;
    } else if (this.state.addrFallback) {
      // Резервен път: свободен текст + белег „Непроверен адрес" за оператора във
      // Ф1. Белегът язди СЪЩЕСТВУВАЩИЯ attributes канал → draft контрактът и
      // тестът срещу #D774 НЕ се пипат (офис/нормалният адрес не носят белег).
      body.city = this.val('fb_city');
      body.zip = this.val('fb_zip');
      body.address1 = this.val('fb_address1');
      body.attributes = withUnverifiedAddress(body.attributes);
    } else {
      var parts = [];
      var head = (this.state.addrStreetType ? this.state.addrStreetType + ' ' : '') +
        (this.state.addrStreetName || '') + ' №' + this.val('addr_no');
      parts.push(head.trim());
      if (this.val('addr_block')) parts.push('бл. ' + this.val('addr_block'));
      if (this.val('addr_entrance')) parts.push('вх. ' + this.val('addr_entrance'));
      if (this.val('addr_floor')) parts.push('ет. ' + this.val('addr_floor'));
      if (this.val('addr_apt')) parts.push('ап. ' + this.val('addr_apt'));
      // Контрактът с бекенда е непроменен: град/пощ.код/address1 (Ф1 чете address1).
      body.city = this.state.addrSiteName || '';
      body.zip = this.state.addrZip || '';
      body.address1 = parts.join(', ');
    }
    return body;
  };

  Widget.prototype.setSubmitting = function (on) {
    this.state.submitting = on;
    if (this.cta) { this.cta.disabled = on; this.cta.classList.toggle('is-loading', on); }
    if (this.ctaLabel) this.ctaLabel.textContent = on ? 'Обработваме…' : L.ctaLabel(this.state.step, this.methodSelected());
  };

  /* ---- Грешки ---- */
  Widget.prototype.setError = function (name, msg) {
    var el = this.form.querySelector('[data-f2-error="' + name + '"]');
    if (el) { el.textContent = msg; el.classList.add('is-visible'); }
  };
  Widget.prototype.clearError = function (name) {
    var el = this.form.querySelector('[data-f2-error="' + name + '"]');
    if (el) { el.textContent = ''; el.classList.remove('is-visible'); }
  };
  Widget.prototype.clearAllErrors = function () {
    var els = this.form.querySelectorAll('[data-f2-error]');
    Array.prototype.forEach.call(els, function (el) { el.textContent = ''; el.classList.remove('is-visible'); });
    if (this.formError) { this.formError.hidden = true; this.formError.textContent = ''; }
  };
  Widget.prototype.showFormError = function (msg) {
    if (!this.formError) return;
    this.formError.hidden = false;
    this.formError.textContent = msg;
  };

  /* ---- Помощни ---- */

  function apiGet(url) {
    return fetch(url, { method: 'GET', mode: 'cors', credentials: 'omit', headers: { 'Accept': 'application/json' } })
      .then(handleResponse);
  }
  function apiPost(url, body, extraHeaders) {
    var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    if (extraHeaders) for (var k in extraHeaders) headers[k] = extraHeaders[k];
    return fetch(url, { method: 'POST', mode: 'cors', credentials: 'omit', headers: headers, body: JSON.stringify(body) })
      .then(handleResponse);
  }
  function handleResponse(r) {
    if (r.status === 429) return r.json().catch(function () { return {}; }).then(function () { throw { rateLimited: true }; });
    return r.json().catch(function () { throw { network: true }; }).then(function (data) {
      if (!r.ok) throw { code: (data && data.error) || 'SERVER_ERROR', status: r.status };
      return data;
    });
  }

  function readCartDiscountCodes(cart) {
    if (cart && Array.isArray(cart.discount_codes)) {
      var codes = cart.discount_codes
        .filter(function (d) { return d && d.applicable && d.code; })
        .map(function (d) { return d.code; });
      return codes.length ? codes : undefined;
    }
    return undefined;
  }

  // Добавя белег „Непроверен адрес" към cart атрибутите (обект или масив →
  // връща обект). Ползва се само по резервния път; бекендът вече прекарва
  // attributes през customAttributes, затова draft контрактът не се пипа.
  function withUnverifiedAddress(attributes) {
    var out = {};
    if (Array.isArray(attributes)) {
      attributes.forEach(function (a) { if (a && a.name != null) out[a.name] = a.value; });
    } else if (attributes && typeof attributes === 'object') {
      for (var k in attributes) {
        if (Object.prototype.hasOwnProperty.call(attributes, k)) out[k] = attributes[k];
      }
    }
    out['Непроверен адрес'] = 'Да';
    return out;
  }

  function plural(n, one, few, many) {
    if (n === 1) return one;
    return n >= 2 && n <= 4 ? few : many;
  }

  function emptyLi(text) {
    var li = document.createElement('li');
    li.className = 'marmot-f2__office-empty';
    li.textContent = text;
    return li;
  }

  function setText(root, sel, txt) {
    var el = root.querySelector(sel);
    if (el) el.textContent = txt;
  }
  function show(el) { if (el) el.hidden = false; }
  function hide(el) { if (el) el.hidden = true; }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function uuid() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  /* ---- Bootstrap ---- */
  function boot() {
    var el = document.getElementById('marmot-f2');
    if (el) init(el);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
